import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { select_filtered_devices } from '../redux/selectors';
import { UniversalDialog } from '../dialogs/universal';
import { closeSelectingDevicesDialog } from './actions';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { SelectingDevicesComponent } from './component';
import { Button } from '@mui/material';
import { selectNullableSelectedDeviceId } from 'entities/device/lib';
const SelectingDevicesDialogImpl = memo(function SelectingDevicesDialogImpl(props) {
    const { devices, dialog_state, closeDialog, selected_device_id } = props;
    let filter_devices = devices;
    if (dialog_state.filter_function?.(filter_devices)) {
        filter_devices = dialog_state.filter_function(filter_devices);
    }
    const [selected_device_ids, setSelectedDeviceID] = useState(dialog_state.selected_devices_ids.length > 0
        ? dialog_state.selected_devices_ids
        : selected_device_id != null
            ? [selected_device_id]
            : []);
    const onCloseDialog = useCallback(() => {
        closeDialog(selected_device_ids);
    }, [closeDialog, selected_device_ids]);
    const onOkClick = useCallback(() => {
        dialog_state.on_ok_function?.(selected_device_ids);
        closeDialog(selected_device_ids);
    }, [closeDialog, selected_device_ids, dialog_state.on_ok_function]);
    return (_jsx(ErrorBoundary, { children: _jsx(UniversalDialog, { open: dialog_state.open, onClose: onCloseDialog, maxWidth: "xs", title: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432", footer: _jsx(Button, { onClick: onOkClick, color: "primary", children: "OK" }), children: _jsx(SelectingDevicesComponent, { devices: filter_devices, selected_device_ids: selected_device_ids, onChangeSelectedDeviceIds: setSelectedDeviceID }) }) }));
});
const SelectingDevicesDialogKey = memo(function SelectingDevicesDialogKey(props) {
    return _jsx(SelectingDevicesDialogImpl, { ...props }, props.dialog_state.randomKey);
});
export const SelectingDevicesDialog = connect(createStructuredSelector({
    devices: select_filtered_devices,
    selected_device_id: selectNullableSelectedDeviceId,
    dialog_state: (state) => state.selecting_devices_ids_dialog,
}), {
    closeDialog: closeSelectingDevicesDialog,
})(SelectingDevicesDialogKey);
